import { render, staticRenderFns } from "./EmissionSource.vue?vue&type=template&id=3387e366&scoped=true"
import script from "./EmissionSource.vue?vue&type=script&lang=js"
export * from "./EmissionSource.vue?vue&type=script&lang=js"
import style0 from "./EmissionSource.vue?vue&type=style&index=0&id=3387e366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3387e366",
  null
  
)

export default component.exports